import RangeGroup from '../../../../components/shared/rangegroup/RangeGroup.js'
import {optionalValidationTypes, toastTypes} from '../../../../helpers/constants.js'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import SwitchGroup from "../../../shared/switchgroup/SwitchGroup.js";
import {Button} from "react-bootstrap";
import InputGroupWithMessages from "../../../shared/inputgroupwithmessages/InputGroupWithMessages.js";
import {getParameterToShow, updateFieldIfChanged} from "../../../../helpers/settingsHelper.js";
import {addParameterIfChanged, validateParameter} from "../../../../helpers/awareSettingsHelper.js";
import {InfoCircleFill} from 'react-bootstrap-icons';
import {cloneDeep} from "lodash";
import PopOverDialog from "../../../shared/popoverdialog/PopOverDialog.js";
import {addToast} from "../../../../helpers/reduxstore/reducers/toastReducer.js";
import {useDispatch} from "react-redux";
import {DatePicker} from '@mui/x-date-pickers'
import DeviceConfigTopInformation from "../../../shared/topinformation/DeviceConfigTopInformation.js";
import SettingsSubHeader from "../../settingscomponents/SettingsSubHeader.js";
import {awareParamNames} from "../../../parameters/awareParamSpec.js";
import Accordion from 'react-bootstrap/Accordion';
import moment from 'moment'

/** Displays the configuration page for setpoints settings
 * @param {object} device device object
 * @param {string} className classes for the component wrapper
 * @param {function} save save function to trigger displaying group selector or confirmation (for single device)
 */
export default function SetpointsSettings({device, className, save}) {
    const {t} = useTranslation(['settingspage', 'common', 'locales'])    
    const dispatch = useDispatch()
    const concentration_heating_pad_installed = device.device_twin.reported.parameters[awareParamNames.condensation_heating_pad_installed]
    const [oldDeviceState, setOldDeviceState] = useState(cloneDeep(device))
    const [summerStartDate, setSummerStartDate] = useState(getParameterToShow(device, awareParamNames.summer_period_start_date, t))
    const [summerActiveCoolingAllowed, setSummerActiveCoolingAllowed] = useState(getParameterToShow(device, awareParamNames.summer_period_active_cooling_allowed, t))
    const [summerActiveHeatingAllowed, setSummerActiveHeatingAllowed] = useState(getParameterToShow(device, awareParamNames.summer_period_active_heating_allowed, t))
    const [summerDeltaTempCooling, setSummerDeltaTempCooling] = useState(getParameterToShow(device, awareParamNames.summer_period_trt_cooling, t))
    const [summerDeltaTempHeating, setSummerDeltaTempHeating] = useState(getParameterToShow(device, awareParamNames.summer_period_trt_heating, t))
    const [summerInletTemperatureMin, setSummerInletTemperatureMin] = useState(getParameterToShow(device, awareParamNames.summer_period_min_rqt, t))
    const [summerInletTemperatureMax, setSummerInletTemperatureMax] = useState(getParameterToShow(device, awareParamNames.summer_period_max_rqt, t))
    const [winterStartDate, setWinterStartDate] = useState(getParameterToShow(device, awareParamNames.winter_period_start_date, t))
    const [winterActiveCoolingAllowed, setWinterActiveCoolingAllowed] = useState(getParameterToShow(device, awareParamNames.winter_period_active_cooling_allowed, t))
    const [winterActiveHeatingAllowed, setWinterActiveHeatingAllowed] = useState(getParameterToShow(device, awareParamNames.winter_period_active_heating_allowed, t))
    const [winterDeltaTempCooling, setWinterDeltaTempCooling] = useState(getParameterToShow(device, awareParamNames.winter_period_trt_cooling, t))
    const [winterDeltaTempHeating, setWinterDeltaTempHeating] = useState(getParameterToShow(device, awareParamNames.winter_period_trt_heating, t))
    const [winterInletTemperatureMin, setWinterInletTemperatureMin] = useState(getParameterToShow(device, awareParamNames.winter_period_min_rqt, t))
    const [winterInletTemperatureMax, setWinterInletTemperatureMax] = useState(getParameterToShow(device, awareParamNames.winter_period_max_rqt, t))
    const [co2ControlMin, setCo2ControlMin] = useState(getParameterToShow(device, awareParamNames.co2_control_min, t))
    const [co2ControlMax, setCo2ControlMax] = useState(getParameterToShow(device, awareParamNames.co2_control_max, t))
    const [flowLimitMin, setflowLimitMin] = useState(getParameterToShow(device, awareParamNames.min_flow_setpoint, t))
    const [flowLimitMax, setflowLimitMax] = useState(getParameterToShow(device, awareParamNames.max_flow_setpoint, t))
    const [motionStartDelayTime, setMotionStartDelayTime] = useState(getParameterToShow(device, awareParamNames.motion_start_delay_time, t))
    const [motionAfterrunTimer, setMotionAfterrunTimer] = useState(getParameterToShow(device, awareParamNames.motion_afterrun_timer, t))
    const [nightCoolingMinTempDifference, setNightCoolingMinTempDifference] = useState(getParameterToShow(device, awareParamNames.night_cooling_min_temp_difference, t))
    const [nightCoolingTrt, setNightCoolingTrt] = useState(getParameterToShow(device, awareParamNames.night_cooling_trt, t))
    const [nightCoolingActiveAllowed, setNightCoolingActiveAllowed] = useState(getParameterToShow(device, awareParamNames.night_cooling_active_allowed, t))

    useEffect(() => {
        // When device is updated after write, update parameters to show / hide messages
        updateFieldIfChanged(setSummerStartDate, oldDeviceState, device, awareParamNames.summer_period_start_date, t)
        updateFieldIfChanged(setSummerActiveCoolingAllowed, oldDeviceState, device, awareParamNames.summer_period_active_cooling_allowed, t)
        updateFieldIfChanged(setSummerActiveHeatingAllowed, oldDeviceState, device, awareParamNames.summer_period_active_heating_allowed, t)
        updateFieldIfChanged(setSummerDeltaTempCooling, oldDeviceState, device, awareParamNames.summer_period_trt_cooling, t)
        updateFieldIfChanged(setSummerDeltaTempHeating, oldDeviceState, device, awareParamNames.summer_period_trt_heating, t)
        updateFieldIfChanged(setSummerInletTemperatureMin, oldDeviceState, device, awareParamNames.summer_period_min_rqt, t)
        updateFieldIfChanged(setSummerInletTemperatureMax, oldDeviceState, device, awareParamNames.summer_period_max_rqt, t)
        updateFieldIfChanged(setWinterStartDate, oldDeviceState, device, awareParamNames.winter_period_start_date, t)
        updateFieldIfChanged(setWinterActiveCoolingAllowed, oldDeviceState, device, awareParamNames.winter_period_active_cooling_allowed, t)
        updateFieldIfChanged(setWinterActiveHeatingAllowed, oldDeviceState, device, awareParamNames.winter_period_active_heating_allowed, t)
        updateFieldIfChanged(setWinterDeltaTempCooling, oldDeviceState, device, awareParamNames.winter_period_trt_cooling, t)
        updateFieldIfChanged(setWinterDeltaTempHeating, oldDeviceState, device, awareParamNames.winter_period_trt_heating, t)
        updateFieldIfChanged(setWinterInletTemperatureMin, oldDeviceState, device, awareParamNames.winter_period_min_rqt, t)
        updateFieldIfChanged(setWinterInletTemperatureMax, oldDeviceState, device, awareParamNames.winter_period_max_rqt, t)
        updateFieldIfChanged(setCo2ControlMin, oldDeviceState, device, awareParamNames.co2_control_min, t)
        updateFieldIfChanged(setCo2ControlMax, oldDeviceState, device, awareParamNames.co2_control_max, t)
        updateFieldIfChanged(setflowLimitMin, oldDeviceState, device, awareParamNames.min_flow_setpoint, t)
        updateFieldIfChanged(setflowLimitMax, oldDeviceState, device, awareParamNames.max_flow_setpoint, t)
        updateFieldIfChanged(setMotionStartDelayTime, oldDeviceState, device, awareParamNames.motion_start_delay_time, t)
        updateFieldIfChanged(setMotionAfterrunTimer, oldDeviceState, device, awareParamNames.motion_afterrun_timer, t)
        updateFieldIfChanged(setNightCoolingMinTempDifference, oldDeviceState, device, awareParamNames.night_cooling_min_temp_difference, t)
        updateFieldIfChanged(setNightCoolingTrt, oldDeviceState, device, awareParamNames.night_cooling_trt, t)
        updateFieldIfChanged(setNightCoolingActiveAllowed, oldDeviceState, device, awareParamNames.night_cooling_active_allowed, t)       
        setOldDeviceState(cloneDeep(device))
    }, [device])

    /**
     * validates parameters. Adds messages to viewmodels if fail. returns true if all is validated, otherwise false.
     * @returns {boolean}
     */
    const validateParameters = () => {
        let validatedList = [true]
        validatedList.push(validateParameter(awareParamNames.summer_period_start_date, summerStartDate, setSummerStartDate, t))
        validatedList.push(validateParameter(awareParamNames.summer_period_active_cooling_allowed, summerActiveCoolingAllowed, setSummerActiveCoolingAllowed, t))
        validatedList.push(validateParameter(awareParamNames.summer_period_active_heating_allowed, summerActiveHeatingAllowed, setSummerActiveHeatingAllowed, t))
        validatedList.push(validateParameter(awareParamNames.summer_period_trt_cooling, summerDeltaTempCooling, setSummerDeltaTempCooling, t,))
        validatedList.push(validateParameter(awareParamNames.summer_period_trt_heating, summerDeltaTempHeating, setSummerDeltaTempHeating, t,
            [{type: optionalValidationTypes.leftLessThanRight, rightModel: summerDeltaTempCooling}]))
        validatedList.push(validateParameter(awareParamNames.summer_period_min_rqt, summerInletTemperatureMin, setSummerInletTemperatureMin, t,
            [{type: optionalValidationTypes.leftLessThanRight, rightModel: summerInletTemperatureMax}]))
        validatedList.push(validateParameter(awareParamNames.summer_period_max_rqt, summerInletTemperatureMax, setSummerInletTemperatureMax, t))
        validatedList.push(validateParameter(awareParamNames.winter_period_trt_cooling, winterDeltaTempCooling, setWinterDeltaTempCooling, t))
        validatedList.push(validateParameter(awareParamNames.winter_period_trt_heating, winterDeltaTempHeating, setWinterDeltaTempHeating, t,
             [{type: optionalValidationTypes.leftLessThanRight, rightModel: winterDeltaTempCooling}]))
        validatedList.push(validateParameter(awareParamNames.winter_period_min_rqt, winterInletTemperatureMin, setWinterInletTemperatureMin, t,
            [{type: optionalValidationTypes.leftLessThanRight, rightModel: winterInletTemperatureMax}]))
        validatedList.push(validateParameter(awareParamNames.winter_period_max_rqt, winterInletTemperatureMax, setWinterInletTemperatureMax, t))
        validatedList.push(validateParameter(awareParamNames.co2_control_min, co2ControlMin, setCo2ControlMin, t,
            [{type: optionalValidationTypes.leftLessThanRight, rightModel: co2ControlMax}]))
        validatedList.push(validateParameter(awareParamNames.co2_control_max, co2ControlMax, setCo2ControlMax, t))
        validatedList.push(validateParameter(awareParamNames.min_flow_setpoint, flowLimitMin, setflowLimitMin, t,
            [{type: optionalValidationTypes.leftLessThanRight, rightModel: flowLimitMax}]))
        validatedList.push(validateParameter(awareParamNames.max_flow_setpoint, flowLimitMax, setflowLimitMax, t))
        validatedList.push(validateParameter(awareParamNames.motion_start_delay_time, motionStartDelayTime, setMotionStartDelayTime, t))
        validatedList.push(validateParameter(awareParamNames.motion_afterrun_timer, motionAfterrunTimer, setMotionAfterrunTimer, t))
        validatedList.push(validateParameter(awareParamNames.night_cooling_min_temp_difference, nightCoolingMinTempDifference, setNightCoolingMinTempDifference, t))
        validatedList.push(validateParameter(awareParamNames.night_cooling_trt, nightCoolingTrt, setNightCoolingTrt, t))
        validatedList.push(validateParameter(awareParamNames.night_cooling_active_allowed, nightCoolingActiveAllowed, setNightCoolingActiveAllowed, t))
        return validatedList.every(v => v)
    }

    const getValuesToSave = () => {
        const updated_parameters = {}
        addParameterIfChanged(updated_parameters, awareParamNames.summer_period_start_date, summerStartDate.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.summer_period_active_cooling_allowed, summerActiveCoolingAllowed.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.summer_period_active_heating_allowed, summerActiveHeatingAllowed.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.summer_period_trt_cooling, summerDeltaTempCooling.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.summer_period_trt_heating, summerDeltaTempHeating.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.summer_period_min_rqt, summerInletTemperatureMin.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.summer_period_max_rqt, summerInletTemperatureMax.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.winter_period_start_date, winterStartDate.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.winter_period_active_cooling_allowed, winterActiveCoolingAllowed.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.winter_period_active_heating_allowed, winterActiveHeatingAllowed.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.winter_period_trt_cooling, winterDeltaTempCooling.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.winter_period_trt_heating, winterDeltaTempHeating.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.winter_period_min_rqt, winterInletTemperatureMin.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.winter_period_max_rqt, winterInletTemperatureMax.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.co2_control_min, co2ControlMin.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.co2_control_max, co2ControlMax.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.min_flow_setpoint, flowLimitMin.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.max_flow_setpoint, flowLimitMax.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.motion_start_delay_time, motionStartDelayTime.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.motion_afterrun_timer, motionAfterrunTimer.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.night_cooling_min_temp_difference, nightCoolingMinTempDifference.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.night_cooling_trt, nightCoolingTrt.value, device)
        addParameterIfChanged(updated_parameters, awareParamNames.night_cooling_active_allowed, nightCoolingActiveAllowed.value, device)
        return updated_parameters
    }

    function saveIfValidated(saveForGroup) {
        if (!validateParameters()) return

        let valuesToSave = getValuesToSave();
        if (Object.keys(valuesToSave).length === 0) {
            dispatch(addToast({
                id: "SetpointsSettingsInfoToast",
                type: toastTypes.info,
                title: "No changes",
                body: "No changes to parameters",
                timeSeconds: 3
            }))
            return
        }
        save(valuesToSave, saveForGroup);
    }

    function setCo2ControlMinAndValidate(newValue) {
        let messages = [];
        setCo2ControlMin({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setCo2ControlMaxAndValidate(newValue) {
        let messages = [];
        setCo2ControlMax({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setFlowLimitMinAndValidate(newValue) {
        let messages = [];
        setflowLimitMin({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setFlowLimitMaxAndValidate(newValue) {
        let messages = [];
        setflowLimitMax({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setMotionStartDelayTimeAndValidate(newValue) {
        let messages = [];
        setMotionStartDelayTime({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setMotionAfterrunTimerAndValidate(newValue) {
        let messages = [];
        setMotionAfterrunTimer({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setSummerDeltaTempCoolingAndValidate(newValue) {
        let messages = [];
        setSummerDeltaTempCooling({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setSummerInletTemperatureMinAndValidate(newValue) {
        let messages = [];
        setSummerInletTemperatureMin({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setSummerInletTemperatureMaxAndValidate(newValue) {
        let messages = [];
        setSummerInletTemperatureMax({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setWinterInletTemperatureMinAndValidate(newValue) {
        let messages = [];
        setWinterInletTemperatureMin({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setWinterInletTemperatureMaxAndValidate(newValue) {
        let messages = [];
        setWinterInletTemperatureMax({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setSummerDeltaTempHeatingAndValidate(newValue) {
        let messages = [];
        setSummerDeltaTempHeating({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setWinterDeltaTempCoolingAndValidate(newValue) {
        let messages = [];
        setWinterDeltaTempCooling({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }

    function setWinterDeltaTempHeatingAndValidate(newValue) {
        let messages = [];
        setWinterDeltaTempHeating({value: newValue, messages: messages})
        return messages.length === 0 // true === no error
    }


    return (
        <div className={className}>
            <DeviceConfigTopInformation title={t('settingspage:setpoints_settings_aware.title')}
                                        subTitle={t('settingspage:setpoints_settings_aware.description')}/>

            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{t('locales:device_setpoints_comfort_header_comfort')}</Accordion.Header>
                    <Accordion.Body>
                         <SettingsSubHeader>{t('locales:device_setpoints_comfort_header_summer_season')}</SettingsSubHeader>
                            <div className="my-5 mt-sm-3 d-flex flex-wrap justify-content-xs-center">
                                    <div className='w-300px d-flex align-items-end'>   
                                        <RangeGroup
                                            label={t('locales:device_setpoints_comfort_header_summer_room_temperature_setpoint')}
                                            rightLabel={t('locales:device_setpoints_comfort_header_summer_cooling')}
                                            leftLabel={t('locales:device_setpoints_comfort_header_summer_heating')}
                                            className='p-4 m-auto'
                                            unit='°C'
                                            type='number'
                                            rightValue={Number(summerDeltaTempCooling.value)}
                                            rightOnChange={e => setSummerDeltaTempCoolingAndValidate(Number(e.target.value))}
                                            rightPlaceholder={0}
                                            rightMessages={summerDeltaTempCooling.messages}
                                            leftValue={Number(summerDeltaTempHeating.value)}
                                            leftOnChange={e => setSummerDeltaTempHeatingAndValidate(Number(e.target.value))}
                                            leftPlaceholder={0}
                                            leftMessages={summerDeltaTempHeating.messages}
                                            separator=' '
                                            disabled={device.slave}
                                            leftInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_summer_room_temperature_setpoint')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10274')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            rightInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_summer_room_temperature_setpoint')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10275')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            />
                                            
                                    </div>        

                                    <div className="d-flex align-items-end">
                                        <div className="p-4">
                                            <div className="mb-2 position-relative">
                                                <span>{t('locales:device_setpoints_comfort_header_summer_start_date')}</span>
                                                {<PopOverDialog
                                                    buttonPosition='position-absolute'
                                                    popOverTitel={t('locales:device_setpoints_comfort_header_summer_start_date')}
                                                    popOverContent={t('locales:device_setpoints_comfort_question_mark_10278')}
                                                    trigger={['hover', 'touch']}
                                                    contentAsHtml={true}/>}
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <DatePicker
                                                    className="bg-white"
                                                    disableHighlightToday={true}
                                                    views={['month', 'day']}
                                                    format={'DD/MM'}
                                                    value={moment((summerStartDate.value ?? 0).toString().padStart(4, '0'), 'MMDD')}
                                                    onChange={v => setSummerStartDate({value: Number(v.format('MMDD')), messages: []})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-end'> 
                                        <SwitchGroup
                                            label={t('locales:device_setpoints_comfort_header_summer_active_cooling_allowed')}
                                            className='p-4'
                                            checked={summerActiveCoolingAllowed.value ?? false}
                                            onChange={(e) => setSummerActiveCoolingAllowed({value: e.target.checked,messages: []})}
                                            messages={summerActiveCoolingAllowed.messages}
                                            infoelement={<PopOverDialog popOverTitel={t('locales:device_setpoints_comfort_header_summer_active_cooling_allowed')}
                                                                        popOverContent={t('locales:device_setpoints_comfort_question_mark_10276')}
                                                                        trigger={['hover', 'touch']}
                                                                        contentAsHtml={true}/>}
                                        />            
                                    </div>
                                    <div className='d-flex align-items-end'> 
                                        <SwitchGroup
                                            label={t('locales:device_setpoints_comfort_header_summer_active_heating_allowed')}
                                            className='p-4'
                                            checked={summerActiveHeatingAllowed.value ?? false}
                                            onChange={(e) => setSummerActiveHeatingAllowed({value: e.target.checked,messages: []})}
                                            messages={summerActiveHeatingAllowed.messages}
                                            infoelement={<PopOverDialog popOverTitel={t('locales:device_setpoints_comfort_header_summer_active_heating_allowed')}
                                                                        popOverContent={t('locales:device_setpoints_comfort_question_mark_10277')}
                                                                        trigger={['hover', 'touch']}
                                                                        contentAsHtml={true}/>}
                                        />            
                                    </div>

                                    <div className='w-300px d-flex align-items-end'>   
                                        <RangeGroup
                                            label={t('locales:device_setpoints_comfort_header_summer_inlet_temperature_limits')}
                                            leftLabel={t('locales:device_setpoints_comfort_header_summer_inlet_temperature_limits_min')}
                                            rightLabel={t('locales:device_setpoints_comfort_header_summer_inlet_temperature_limits_max')}
                                            className='p-4 m-auto'
                                            unit='°C'
                                            type='number'
                                            leftValue={Number(summerInletTemperatureMin.value)}
                                            leftOnChange={e => setSummerInletTemperatureMinAndValidate(Number(e.target.value))}
                                            leftPlaceholder={0}
                                            leftMessages={summerInletTemperatureMin.messages}
                                            rightValue={Number(summerInletTemperatureMax.value)}
                                            rightOnChange={e => setSummerInletTemperatureMaxAndValidate(Number(e.target.value))}
                                            rightPlaceholder={0}
                                            rightMessages={summerInletTemperatureMax.messages}
                                            separator=' '
                                            leftInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_summer_inlet_temperature_limits')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10280')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            rightInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_summer_inlet_temperature_limits')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10279')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            />
                                    </div>        
                            </div>

                         <SettingsSubHeader>{t('locales:device_setpoints_comfort_header_winter_season')}</SettingsSubHeader>
                         <div className="my-5 mt-sm-3 d-flex flex-wrap justify-content-xs-center">
                                    <div className='w-300px d-flex align-items-end'>   
                                        <RangeGroup
                                            label={t('locales:device_setpoints_comfort_header_winter_room_temperature_setpoint')}
                                            rightLabel={t('locales:device_setpoints_comfort_header_winter_cooling')}
                                            leftLabel={t('locales:device_setpoints_comfort_header_winter_heating')}
                                            className='p-4 m-auto'
                                            unit='°C'
                                            type='number'
                                            rightValue={Number(winterDeltaTempCooling.value)}
                                            rightOnChange={e => setWinterDeltaTempCoolingAndValidate(Number(e.target.value))}
                                            rightPlaceholder={0}
                                            rightMessages={winterDeltaTempCooling.messages}
                                            leftValue={Number(winterDeltaTempHeating.value)}
                                            leftOnChange={e => setWinterDeltaTempHeatingAndValidate(Number(e.target.value))}
                                            leftPlaceholder={0}
                                            leftMessages={winterDeltaTempHeating.messages}
                                            separator=' '
                                            disabled={device.slave}
                                            leftInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_winter_room_temperature_setpoint')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10281')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            rightInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_winter_room_temperature_setpoint')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10282')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            />
                                    </div>        

                                    <div className="d-flex align-items-end">
                                        <div className="p-4">
                                            <div className="mb-2 position-relative">
                                                <span>{t('locales:device_setpoints_comfort_header_winter_start_date')}</span>
                                                {<PopOverDialog
                                                    buttonPosition='position-absolute'
                                                    popOverTitel={t('locales:device_setpoints_comfort_header_winter_start_date')}
                                                    popOverContent={t('locales:device_setpoints_comfort_question_mark_10285')}
                                                    trigger={['hover', 'touch']}
                                                    contentAsHtml={true}/>}
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <DatePicker
                                                    className="bg-white"
                                                    disableHighlightToday={true}
                                                    views={['month', 'day']}
                                                    format={'DD/MM'}
                                                    value={moment((winterStartDate.value ?? 0).toString().padStart(4, '0'), 'MMDD')}
                                                    onChange={v => setWinterStartDate({value: Number(v.format('MMDD')), messages: []})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-end'> 
                                        <SwitchGroup
                                            label={t('locales:device_setpoints_comfort_header_winter_active_cooling_allowed')}
                                            className='p-4'
                                            checked={winterActiveCoolingAllowed.value ?? false}
                                            onChange={(e) => setWinterActiveCoolingAllowed({value: e.target.checked,messages: []})}
                                            messages={winterActiveCoolingAllowed.messages}
                                            infoelement={<PopOverDialog popOverTitel={t('locales:device_setpoints_comfort_header_winter_active_cooling_allowed')}
                                                                        popOverContent={t('locales:device_setpoints_comfort_question_mark_10283')}
                                                                        trigger={['hover', 'touch']}
                                                                        contentAsHtml={true}/>}
                                        />            
                                    </div>
                                    <div className='d-flex align-items-end'> 
                                        <SwitchGroup
                                            label={t('locales:device_setpoints_comfort_header_winter_active_heating_allowed')}
                                            className='p-4'
                                            checked={winterActiveHeatingAllowed.value ?? false}
                                            onChange={(e) => setWinterActiveHeatingAllowed({value: e.target.checked,messages: []})}
                                            messages={winterActiveHeatingAllowed.messages}
                                            infoelement={<PopOverDialog popOverTitel={t('locales:device_setpoints_comfort_header_winter_active_heating_allowed')}
                                                                        popOverContent={t('locales:device_setpoints_comfort_question_mark_10284')}
                                                                        trigger={['hover', 'touch']}
                                                                        contentAsHtml={true}/>}
                                        />            
                                    </div>

                                    <div className='w-300px d-flex align-items-end'>   
                                        <RangeGroup
                                            label={t('locales:device_setpoints_comfort_header_winter_inlet_temperature_limits')}
                                            leftLabel={t('locales:device_setpoints_comfort_header_winter_inlet_temperature_limits_min')}
                                            rightLabel={t('locales:device_setpoints_comfort_header_winter_inlet_temperature_limits_max')}
                                            className='p-4'
                                            unit='°C'
                                            type='number'
                                            leftValue={Number(winterInletTemperatureMin.value)}
                                            leftOnChange={e => setWinterInletTemperatureMinAndValidate(Number(e.target.value))}
                                            leftPlaceholder={0}
                                            leftMessages={winterInletTemperatureMin.messages}
                                            rightValue={Number(winterInletTemperatureMax.value)}
                                            rightOnChange={e => setWinterInletTemperatureMaxAndValidate(Number(e.target.value))}
                                            rightPlaceholder={0}
                                            rightMessages={winterInletTemperatureMax.messages}
                                            separator=' '
                                            disabled={device.slave}
                                            leftInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_winter_inlet_temperature_limits')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10287')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            rightInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_winter_inlet_temperature_limits')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10286')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            />
                                    </div>        
                         </div>

                         <SettingsSubHeader>{t('locales:device_setpoints_comfort_header_co2')}</SettingsSubHeader>
                         <div className="my-5 mt-sm-3 d-flex flex-wrap justify-content-xs-center">
                                    <div className='w-300px d-flex align-items-end'>   
                                        <RangeGroup
                                            label={t('locales:device_setpoints_comfort_header_co2_setpoints')}
                                            leftLabel={t('settingspage:parameters.min')}
                                            rightLabel={t('settingspage:parameters.max')}
                                            className='p-4 m-auto'
                                            unit='ppm'
                                            type='number'
                                            leftValue={Number(co2ControlMin.value)}
                                            leftOnChange={e => setCo2ControlMinAndValidate(Number(e.target.value))}
                                            leftPlaceholder={0}
                                            leftMessages={co2ControlMin.messages}
                                            rightValue={Number(co2ControlMax.value)}
                                            rightOnChange={e => setCo2ControlMaxAndValidate(Number(e.target.value))}
                                            rightPlaceholder={0}    
                                            rightMessages={co2ControlMax.messages}
                                            separator=' '
                                            leftInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_co2_setpoints')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10009')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            rightInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_co2_setpoints')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10010')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            />
                                    </div>        
                                    <div className='w-300px d-flex align-items-end'>   
                                        <RangeGroup
                                            label={t('locales:device_setpoints_comfort_header_flow_limits')}
                                            leftLabel={t('settingspage:parameters.min')}
                                            rightLabel={t('settingspage:parameters.max')}
                                            className='p-4 m-auto'
                                            unit='%'
                                            type='number'
                                            leftValue={Number(flowLimitMin.value)}
                                            leftOnChange={e => setFlowLimitMinAndValidate(Number(e.target.value))}
                                            leftPlaceholder={0}
                                            leftMessages={flowLimitMin.messages}
                                            rightValue={Number(flowLimitMax.value)}
                                            rightOnChange={e => setFlowLimitMaxAndValidate(Number(e.target.value))}
                                            rightPlaceholder={0}
                                            rightMessages={flowLimitMax.messages}
                                            separator=' '
                                            leftInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_flow_limits')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10004')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            rightInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_flow_limits')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10005')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            />
                                    </div>            
                         </div>

                         <SettingsSubHeader>{t('locales:device_setpoints_comfort_header_start_signals')}</SettingsSubHeader>
                         <div className="my-5 mt-sm-3 d-flex flex-wrap justify-content-xs-center">
                                    <div className='w-330px d-flex align-items-end'>   
                                        <RangeGroup
                                            label={t('locales:device_setpoints_comfort_header_motion_sensor')}
                                            leftLabel={t('locales:device_setpoints_comfort_header_motion_sensor_start_delay')}
                                            rightLabel={t('locales:device_setpoints_comfort_header_motion_sensor_afterrun_time')}
                                            className='p-4 m-auto'
                                            leftUnit='sec.'
                                            rightUnit='min.'
                                            type='number'
                                            leftValue={Number(motionStartDelayTime.value)}
                                            leftOnChange={e => setMotionStartDelayTimeAndValidate(Number(e.target.value))}
                                            leftPlaceholder={0}
                                            leftMessages={motionStartDelayTime.messages}
                                            rightValue={Number(motionAfterrunTimer.value)}
                                            rightOnChange={e => setMotionAfterrunTimerAndValidate(Number(e.target.value))}
                                            rightPlaceholder={0}
                                            rightMessages={motionAfterrunTimer.messages}
                                            separator=' '
                                            leftInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_motion_sensor')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10271')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            rightInfoelement={<PopOverDialog
                                                buttonPosition='position-absolute'
                                                popOverTitel={t('locales:device_setpoints_comfort_header_motion_sensor')}
                                                popOverContent={t('locales:device_setpoints_comfort_question_mark_10270')}
                                                trigger={['hover', 'touch']}
                                                contentAsHtml={true}/>}
                                            />
                                    </div>               
                         </div>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>{t('settingspage:setpoints_settings_aware.night_cooling')}</Accordion.Header>
                    <Accordion.Body>
                        <div className="mt-sm-3 d-flex flex-wrap justify-content-xs-center">
                            <div className='w-300px d-flex align-items-end'> 
                                <InputGroupWithMessages
                                    label={t('locales:device_setpoints_night_cooling_header_minimum_temp._difference')}
                                    className='p-4 m-auto'
                                    value={nightCoolingMinTempDifference.value}
                                    unit='°C'
                                    inputValue={(e) => setNightCoolingMinTempDifference({value: e.target.value})}
                                    placeholder={t('common:units.degrees')}
                                    messages={nightCoolingMinTempDifference.messages}
                                    type='number'
                                    infoelement={<PopOverDialog
                                        popOverTitel={t('locales:device_setpoints_night_cooling_header_minimum_temp._difference')}
                                        popOverContent={t('locales:device_setpoints_night_cooling_question_mark_10290')}
                                        trigger={['hover', 'touch']}
                                        contentAsHtml={true}/>}
                                />
                            </div>
                            <div className='w-300px d-flex align-items-end'> 
                                <InputGroupWithMessages
                                    label={t('locales:device_setpoints_night_cooling_header_room_temperature_setpoint')}
                                    className='p-4 m-auto'
                                    value={nightCoolingTrt.value}
                                    unit='°C'
                                    inputValue={(e) => setNightCoolingTrt({value: e.target.value})}
                                    placeholder={t('common:units.degrees')}
                                    messages={nightCoolingTrt.messages}
                                    type='number'
                                    infoelement={<PopOverDialog
                                        popOverTitel={t('locales:device_setpoints_night_cooling_header_room_temperature_setpoint')}
                                        popOverContent={t('locales:device_setpoints_night_cooling_question_mark_10288')}
                                        trigger={['hover', 'touch']}
                                        contentAsHtml={true}/>}
                                />
                            </div>


                            {concentration_heating_pad_installed  &&
                                <div className='d-flex align-items-end'> 
                                    <SwitchGroup
                                        label={t('locales:device_setpoints_night_cooling_header_cooling')}
                                        className='p-4'
                                        checked={nightCoolingActiveAllowed.value ?? false}
                                        onChange={(e) => setNightCoolingActiveAllowed({value: e.target.checked,messages: []})}
                                        messages={nightCoolingActiveAllowed.messages}
                                        infoelement={<PopOverDialog popOverTitel={t('locales:device_setpoints_night_cooling_header_cooling')}
                                                                    popOverContent={t('locales:device_setpoints_night_cooling_question_mark_10291')}
                                                                    trigger={['hover', 'touch']}
                                                                    contentAsHtml={true}/>}
                                    />            
                                </div>
                            }
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>


            <div className="alert alert-info" hidden={!device.slave}>
                <InfoCircleFill className='me-1 mb-1 text-primary'/>{t('settingspage:slave-device-settings')}
                {device.master_serial_number &&
                    <a href={"/device/" + device.master_serial_number + "/configurations/setpoints"}>{device.master_serial_number}</a>}
            </div>

            {/*=== Button container*/}
            <div className='d-inline-block float-end p-2'>
                <Button variant='outline-secondary' disabled={device.slave} onClick={() => saveIfValidated(false)}
                        className='me-2'>
                    {t('settingspage:save_device')}</Button>
                <Button variant='outline-secondary' disabled={device.slave} onClick={() => saveIfValidated(true)}>
                    {t('settingspage:save_group')}</Button>
            </div>
        </div>
    )
}